<template>
  <div id="app">
    <Headers />
    <div class="header-footer">
      <router-view :key="this.$route.path" />
<!-- 
      <keep-alive exclude="Appointment">
      </keep-alive> -->
    </div>
    <Footer :copyright="copyright" />
  </div>
</template>
<script>
import Headers from "@c/FDHeader";
import Footer from "@c/Footer";
export default {
  name: "",
  components: { Headers, Footer },
  data() {
    return {
      logo: "",
      copyright: {},
    };
  },
};
</script>
<style lang="scss">
html,
body {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}
.contanner {
  width: 1200px;
  margin: 0 auto;
}
.header-footer {
  min-height: 400px;
  // min-width: 1890px;
}
li {
  list-style: none;
}

#app {
  font-family: "Noto", Sans SC, Source Han Sans CN, PingFang SC, Microsoft Yahei,
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
  width: 100%;
  height: 100%;
  > .el-scrollbar {
    min-width: 1200px;
  }
  .el-scrollbar__wrap {
    overflow-y: scroll;
    overflow-x: auto;
  }
  .el-scrollbar__thumb {
    opacity: 0;
  }
  .ellipsis {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .ellipsis_3 {
    display: -webkit-box;
    word-break: break-all;
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
  }
  .status_1 {
    background: #2f69ed;
  }
  .status_0 {
    background: #999;
  }
}
* {
  box-sizing: border-box;
}
a,
a:hover,
a:focus {
  text-decoration: none;
  color: #999;
}
body,
div,
dl,
dt,
dd,
ul,
ol,
li,
h1,
h2,
h3,
h4,
h5,
h6,
pre,
form,
fieldset,
input,
textarea,
p,
blockquote,
th,
td {
  margin: 0;
  padding: 0;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
body {
  -webkit-text-size-adjust: none;
}
fieldset,
img {
  border: 0;
}
img {
  vertical-align: middle;
}
address,
caption,
cite,
code,
dfn,
em,
th,
var {
  font-style: normal;
  font-weight: normal;
}
ol,
ul {
  list-style: none;
}
caption,
th {
  text-align: left;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 100%;
  font-weight: normal;
}
q:before,
q:after {
  content: "";
}
abbr,
acronym {
  border: 0;
}
.clearfix:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: " ";
  clear: both;
  height: 0;
}
.cli {
  clear: both;
  font-size: 0;
  height: 0;
  overflow: hidden;
  display: block;
}
.lclear {
  clear: left;
  font-size: 0;
  height: 0;
  overflow: hidden;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
.title_icon {
  position: relative;
  padding-left: 33px;
  .icon_box1 {
    position: absolute;
    top: 0;
    left: 0;
    height: 15px;
    width: 15px;
    background-color: #004796;
  }
  .icon_box2 {
    position: absolute;
    top: 8px;
    left: 8px;
    height: 10px;
    width: 10px;
    background-color: #ed8016;
  }
  h1 {
    display: inline-block;
    font-size: 30px;
    font-weight: 700;
    line-height: 25px;
  }
}
.Xflex_box {
  display: flex;
  justify-content: space-between;
  
}
.navigation {
  width: 100%;
  box-sizing: border-box;
  background: #f7f7f7;
  .page-cen {
    width: 1200px;
    margin: 0 auto;
    text-align: left;
    .navigation-item {
      font-size: 14px;
      color: #888;
      padding: 15px 0;
      a {
        margin: 0 12px;
      }
    }
    .active {
      color: #004796;
    }
  }
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #337ab7 !important;
  color: #fff;
}

.selected {
  color: #004796 !important;
}

.flex-col {
  display: flex;
  flex-direction: column;
}
.flex-row {
  display: flex;
  flex-direction: row;
}
.justify-start {
  display: flex;
  justify-content: flex-start;
}
.justify-center {
  display: flex;
  justify-content: center;
}
.justify-end {
  display: flex;
  justify-content: flex-end;
}
.justify-evenly {
  display: flex;
  justify-content: space-evenly;
}
.justify-around {
  display: flex;
  justify-content: space-around;
}
.justify-between {
  display: flex;
  justify-content: space-between;
}
.align-start {
  display: flex;
  align-items: flex-start;
}
.align-center {
  display: flex;
  align-items: center;
}
.align-end {
  display: flex;
  align-items: flex-end;
}
</style>
